// Product dimension images lightbox START
(function () {
  function initDimensionLightbox() {
    if (window.dimensionLightboxInitialized) return;

    window.dimensionLightboxInitialized = true;

    document.addEventListener('click', function (event) {

      // Refer Shop Drawings link
      var shopDrawingsLink = event.target.closest('.shop-drawings-link');

      if (shopDrawingsLink) {
        event.preventDefault();

        var popup = document.getElementById('dimension-drawings-popup');

        if (popup) {
          popup.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }

        return;
      }

      // Dimension drawing image
      var link = event.target.closest('.dimension-drawing-link');

      if (!link) return;

      event.preventDefault();

      var imageUrl = link.href;

      if (!imageUrl) return;

      // Create image lightbox
      var lightbox = document.querySelector('.dimension-lightbox');

      if (!lightbox) {
        lightbox = document.createElement('div');
        lightbox.className = 'dimension-lightbox';

        lightbox.innerHTML =
          '<button type="button" class="dimension-lightbox-close" aria-label="Close image">&times;</button>' +
          '<img class="dimension-lightbox-image" src="" alt="">';

        document.body.appendChild(lightbox);

        // Close image lightbox
        lightbox
          .querySelector('.dimension-lightbox-close')
          .addEventListener('click', function () {
            lightbox.classList.remove('is-open');
            document.body.style.overflow = '';
          });

        // Click outside image to close
        lightbox.addEventListener('click', function (event) {
          if (event.target === lightbox) {
            lightbox.classList.remove('is-open');
            document.body.style.overflow = '';
          }
        });
      }

      var image = lightbox.querySelector('.dimension-lightbox-image');

      image.src = imageUrl;
      image.alt = link.querySelector('img')
        ? link.querySelector('img').alt
        : '';

      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          lightbox.classList.add('is-open');
        });
      });
    });

    // Close dimension drawings popup
    document.addEventListener('click', function (event) {
      var closeButton = event.target.closest(
        '.dimension-drawings-popup__close'
      );

      if (closeButton) {
        var popup = document.getElementById('dimension-drawings-popup');

        if (popup) {
          popup.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
    });

    // Close when clicking outside popup content
    document.addEventListener('click', function (event) {
      var popup = document.getElementById('dimension-drawings-popup');

      if (
        popup &&
        event.target === popup
      ) {
        popup.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });

    // Escape key
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {

        var lightbox = document.querySelector('.dimension-lightbox');
        var popup = document.getElementById('dimension-drawings-popup');

        if (lightbox) {
          lightbox.classList.remove('is-open');
        }

        if (popup) {
          popup.classList.remove('is-open');
        }

        document.body.style.overflow = '';
      }
    });
  }

  // Swatch image preview mobile START
  function initMobileColorPreview() {
    function updatePreview(input) {
      var fieldset = input.closest('.option-selector');

      if (!fieldset) return;

      var preview = fieldset.querySelector('.opt-label__image-preview-mobile');

      if (!preview) return;

      var image = preview.querySelector('img');

      if (!image) return;

      var imageUrl = input.getAttribute('data-preview-image');

      if (!imageUrl) {
        preview.classList.remove('is-active');
        return;
      }

      image.src = imageUrl;
      image.alt = input.value;
      preview.classList.add('is-active');
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest('.option-selector input.js-option');

      if (!input) return;

      updatePreview(input);
    });

    // Re-run after Shopify changes the variant options
    document.addEventListener('on:variant:change', function (event) {
      var picker = event.target.closest ? event.target.closest('variant-picker') : null;
      if (!picker) return;

      picker
        .querySelectorAll('.option-selector input.js-option:checked')
        .forEach(function (input) {
          updatePreview(input);
        });
    });

    // Initial selected colour
    document
      .querySelectorAll('.option-selector input.js-option:checked')
      .forEach(function (input) {
        updatePreview(input);
      });
  }
  // Swatch image preview mobile END

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDimensionLightbox();
      initMobileColorPreview();
    });
  } else {
    initDimensionLightbox();
    initMobileColorPreview();
  }

})();
// Product dimension images lightbox END

// Display Left/Right dropdown option when "Corner with Chaise" is selected START
document.querySelectorAll('.js-chaise-wrapper').forEach(function (wrapper) {
  var picker = wrapper.closest('variant-picker');
  if (!picker) return;

  function toggleChaise(sizeValue) {
    var show = /left or right/i.test(sizeValue || '');
    wrapper.hidden = !show;
    wrapper.querySelectorAll('input').forEach(function (input) {
      input.required = show;
    });
  }

  picker.addEventListener('change', function (e) {
    if (e.target.closest('[data-option*="Size"]')) {
        var sizeValue = (e.detail && e.detail.selectedValue) || e.target.value;
        toggleChaise(sizeValue);
    }
  });
});
// Display Left/Right dropdown option when "Corner with Chaise" is selected END